import React from 'react';
import Grid from '@material-ui/core/Grid';
import CircularProgress from '@material-ui/core/CircularProgress';

const Loading = () => {
  return (
    <Grid container style={{ flex: 1 }} direction="column" justifyContent="center" alignItems="center">
      <CircularProgress />
    </Grid>
  );
};

export default Loading;
